import { RedirectRoute } from '../Routing/types';

const redirects: RedirectRoute[] = [
  {
    path: '/measurements/edit',
    redirectTo: `/measurements/edit/${new Date().toISOString().slice(0, 10)}`,
  },
];

export default redirects;
